import { Suspense, useState } from 'react';
import { ClientLoaderFunction, useParams } from 'react-router';
import { ConnectionStatusType } from '@/components/connection-status/connection-status-type.ts';
import { ErrorBanner } from '@/components/error-page/error-banner.tsx';
import { HighlightedFeedWrapper } from '@/components/highlighted-feed-wrapper/highlighted-feed-wrapper.tsx';
import { useStreamLoaderData } from '../_app.p.streams_.$id/loader.ts';
import { SeoHandle } from '../sitemap[.]xml/generate-sitemap.ts';
import { AuthenticatedStreamPreviewAlert } from './authenticated-stream-preview-alert.tsx';
import { DelayedPreviewAlert } from './delayed-preview-alert.tsx';
import { streamPostsLoader } from './loader.ts';
import { streamPostsWrapper } from './page.css.ts';
import { streamSitemap } from './sitemap.ts';
import { StreamPostFeedSkeleton } from './stream-post-feed-skeleton.tsx';
import { StreamPostsAction } from './stream-posts-action.tsx';
import { StreamPostsFeed } from './stream-posts-feed.tsx';
import { StreamPreviewFeed } from './stream-preview-feed.tsx';

export const handle: SeoHandle = {
  sitemap: streamSitemap,
};

export const clientLoader = streamPostsLoader;
(clientLoader as ClientLoaderFunction).hydrate = true;

export const ErrorBoundary = ErrorBanner;

export default function StreamFeed() {
  const [subscriptionStatus, setSubscriptionStatus] = useState(
    ConnectionStatusType.Connected,
  );

  const { authenticated } = useStreamLoaderData();
  const streamId = useParams().id as string;

  const skeletonItemCount = 5;

  return (
    <>
      {authenticated ? (
        <Suspense fallback={null}>
          <AuthenticatedStreamPreviewAlert />
        </Suspense>
      ) : (
        <DelayedPreviewAlert>
          This is a delayed preview. Log in to follow the stream and see new
          posts in real time.
        </DelayedPreviewAlert>
      )}

      <HighlightedFeedWrapper
        label="Data stream"
        className={streamPostsWrapper}
        action={
          authenticated && (
            <Suspense fallback={null}>
              <StreamPostsAction subscriptionStatus={subscriptionStatus} />
            </Suspense>
          )
        }
      >
        <Suspense
          fallback={<StreamPostFeedSkeleton count={skeletonItemCount} />}
        >
          {authenticated ? (
            <StreamPostsFeed
              setSubscriptionStatus={setSubscriptionStatus}
              skeletonItemCount={skeletonItemCount}
            />
          ) : (
            <StreamPreviewFeed
              streamId={streamId}
              skeletonItemCount={skeletonItemCount}
            />
          )}
        </Suspense>
      </HighlightedFeedWrapper>
    </>
  );
}
